<template>
    <div class="mb-4">
        <!-- {{options }} -->
        <div class="row mt-4 text-center">
            <div class="col-3 middleDiv">
                <h5>Brand Cat <span class="text-red">*</span></h5>
            </div>
            <div class="col-2 middleDiv">
                <h5>:</h5>
            </div>
            <div class="col-7">
                <Multiselect
                    v-if="options.cat_brand"
                    v-model="form.cat_brand_id"
                    :options="options.cat_brand.map(x => x.id)"
                    :custom-label="opt => options.cat_brand.find(x => x.id == opt).brand_name"
                    :allow-empty="false"
                    class="w-100"
                />
            </div>
        </div>

        <!-- <table  class="table" v-if="form.cat_brand_id">
            <thead>
                <th>Nomor Workorder</th>
            </thead>
        </table> -->
        <div v-if="form.cat_brand_id" class="mt-4">
            <hr>
            <h5>Pilih Work Order</h5>
            <div class="row">
                <div class="col-9">
                    <Multiselect
                        placeholder="Pilih Nomor WO"
                        v-model="selectWo"
                        :options="this.$options.workorder_list.map(x => x.form_code)"
                        :custom-label="opt => this.$options.workorder_list.find(x => x.form_code == opt).name"

                    ></Multiselect>
                </div>
                <div class="col-3">
                    <button class="btn w-100 btn btn-success" style="height:43px" @click="addCar(null)"><i class="fa fa-plus-circle"></i> Tambah WO</button>
                </div>
               
            </div>

            <hr>

            <div class="row">
                <div class="col-9 mt-auto mb-auto">
                    <h4>Total Price : Rp. {{ numberWithCommas(totalPriceVoucher) }}</h4>
                </div>
                <div class="col-3">
                    <button class="btn btn-primary w-100" @click="uploadExcel = true"><i class="fa fa-excel"></i> Unggah Excel</button>
                </div>
                
            </div>

            <!-- {{ errorList }} -->
            <panel class=" mt-3 mb-3 border border-secondary rounded" v-if="errorList.length > 0" :noExpand="true" :collapseNow="true">
                <template slot="header">
                    <h4 class="panel-title">Show Error List</h4>
                </template>
                <div class="row">
                    <div class="col-6" v-for="(error , index) in errorList">{{ index + 1 }}. {{ error }}</div>
                </div>
                
            </panel>

            <hr>
            <div class="" v-for="(car , carIndex) in form.use_paint_list">
                <!-- {{ car }} -->

                <div class="row">
                    <div class="col-9">
                        <h4>{{ car.form_code }} - {{ car.no_polisi }}</h4>
                    </div>
                    <div class="col-3">
                        <button
                            class="btn btn-warning w-100"
                            @click="addPaint(car)"
                        >
                            <i class="fa fa-plus circle"></i> Tambah Cat
                        </button>
                    </div>
                </div>
                
                <div class="text-right" v-if="car.paint_list.length > 0">
                    <!-- <h5>Total Modal : Rp. {{ car.paint_list.reduce((x , y) => {
                        return parseFloat()
                    }) }}</h5> -->
                </div>

                <h6>Total Harga : Rp. {{ numberWithCommas(car.total_price) }}</h6>

                <table class="table mt-3">
                    <thead>
                        <th>Kode Cat</th>
                        <th>Nama Cat</th>
                        
                        <th>Terpakai</th>
                        <th>Harga / Gram</th>
                        <th>Harga Terpakai</th>
                        <th><i class="fa fa-cog"></i></th>
                    </thead>
                    <!-- <tbody v-for="(paint , index) in car.paint_list">
                        <td style="width: 30%;">
                            <Multiselect 
                                v-model="paint.paint_code"
                                :options="options.paint_list.map(x => x.paint_code)"
                                :allow-empty="false"
                            />
                        </td>
                        <td style="width: 20%;">
                            {{ paint.paint_code ? options.paint_list.find(x => paint.paint_code == x.paint_code).paint_name : '-' }}
                        </td>
                        <td style="width: 30%;">
                            <input type="text" 
                                :disabled="!paint.paint_code"
                                v-model="paint.used_weight"
                                class="form-control"
                                style="height:43px"
                            />
                        </td>
                        <td style="width: 10%;">
                            {{ paint.paint_code && paint.used_weight ? 'Rp. ' + numberWithCommas(parseFloat(options.paint_list.find(x => paint.paint_code == x.paint_code).price_per_weight) / 1000 * parseFloat(paint.used_weight)) : '-'}}
                        </td>
                        <td style="width: 5%;">
                            <button type="button" 
                                @click="car.paint_list.slice(index, 1)"
                                class="btn btn-danger"
                            ><i class="fa fa-times-circle"></i></button>
                        </td>
                    </tbody> -->
                    <selectCat 
                        v-for="(paint , index) in car.paint_list"
                        :key="`${carIndex} ${index}`"
                        :paint="paint"
                        :index="carIndex"
                        :paint_list="options.paint_list"
                        @removeIndex="
                            car.paint_list.splice(index , 1)
                        "
                        @updateCost="updateCost"
                    />
                </table>
                <hr>
            </div>
        </div>

        <uploadFile 
			v-if="uploadExcel"
			@closeModal="uploadExcel = false"
			@file="afterUpload"
			:title="'Unggah Excel Voucher Cat'"
		/>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import uploadFile from '@/components/modal/uploadFile'
import selectCat from './selectCat.vue'
import { format } from 'path'
// import XLSX from 'xlsx'
const XLSX = require('xlsx')


export default {
    components : {
        Multiselect,
        uploadFile,
        selectCat
    },
    data () {
        return {
            uploadExcel : false,
            options : {
                cat_brand : null,
                paint_list : null
            },
            form : {
                cat_brand_id : null,
                supplier_id : null,
                use_paint_list : []
            },
            use_paint_list_model : {
                chassis_number : '', // from wo,
                form_code : '', //nomor wo
                paint_list : [],
                no_polisi : '',
                total_price : 0
            },
            paint_list_model : {
                name : '', // cat name,
                paint_code : '', // kode paint,
                used_weight : '',
                total_price : 0
            },
            selectWo : null,
            errorList : [],
            totalPriceVoucher : 0
        }
    },
    mounted () {
        this.getCatBrand()
        this.loadWorkOrder()
    },
    watch : {
        'form.cat_brand_id' : function () {
            // this.form.use_paint_list = [Object.assign({} , this.use_paint_list_model)]
            
            if(this.form.cat_brand_id) {
                this.getPaintList()
                this.form.supplier_id = this.options.cat_brand.find(x => x.id == this.form.cat_brand_id).supplier_id
            }   
            
        }
    },
    workorder_list : null,
    computed : {
        // totalPriceVoucher : function () {
        //     return this.form.use_paint_list.reduce(function (acc, obj) { return acc + obj.total_price; }, 0);
        // }
    },
    methods : {
        updateCost (index) {

            // this.form.use_paint_list[index].total_price = cost
            let car = this.form.use_paint_list[index]
            let total = 0;

            for(var i = 0 ; i < car.paint_list.length ; i++) {
                // if(car.paint_code)
                let curPaint = car.paint_list[i]

                if(!curPaint.paint_code || !curPaint.used_weight)
                    continue;

                total += curPaint.total_price
            }

            // car.total_price = total
            this.$set(this.form.use_paint_list[index] , 'total_price' , total)
            this.calculateTotal()
            
        },
        calculateTotal () {
            this.totalPriceVoucher = this.form.use_paint_list.reduce(function (acc, obj) { return acc + obj.total_price; }, 0);
        },
        addPaint(car) {
            // console.log(car)
            car.paint_list.push(JSON.parse(JSON.stringify(this.paint_list_model)))
        },
        afterUpload (file) {
			var reader = new FileReader();

			reader.onload = async (e) => {
				/* Parse data */
				const bstr = e.target.result;
                // console.log(bstr)
				const wb = XLSX.read(bstr, { type: 'binary' });
				/* Get first worksheet */
				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];
				/* Convert array of arrays */
				const data = XLSX.utils.sheet_to_json(ws);
                this.errorList = []
                let found = 0;
                let total = 0;

                // console.log(data)

                for(var i = 0 ; i < data.length ; i++) {
                    let curData = data[i]

                    if(!curData['No PKB'])
                        continue;
                    // console.log(curData['No PKB'])

                    let formData = this.$options.workorder_list.find(x => curData['No PKB'] == x.form_code || curData['No Polisi'] == x.no_polisi)

                    if(!formData) {
                        this.errorList.push(`${curData['No PKB']} - ${curData['No Polisi']} not found ! errorWO`);
                        continue;
                    }

                    // console.log(formData.form_code)

                    let keys = Object.keys(curData)

                    let excludeKeys = ['Cabang' , 'No PKB' , 'No Polisi' , 'Tgl SPK' , 'Warna SPK' , 'No']
                    let index = this.addCar(formData.form_code)
                    // console.log(obj)
                    let obj = this.form.use_paint_list[index]

                    // console.log(obj)

                    for(var j = 0 ; j < keys.length ; j++) {
                        let curKey = keys[j].trim()
                        
                        let searchKey = curKey
                        if(excludeKeys.includes(curKey))
                            continue;

                        if(curData[curKey] == '-') {
                            continue
                        }

                        if(searchKey.includes('(')) {
                            searchKey = searchKey.split('(')[0].trim()
                        }
                        total++
                        let paintData = this.options.paint_list.find(x => x.paint_code.trim() == searchKey || x.paint_code.split('/')[0].trim() == searchKey.split('/')[0].trim())
                        // console.log(paintData)
                        if(!paintData){
                            this.errorList.push(`${formData.form_code} - ${curData['No Polisi']} with paint code of ${curKey} not found !`);
                            continue;
                        }

                        let cost = parseFloat(paintData.price_per_weight) / 1000 * parseFloat(curData[curKey])
                        obj.total_price += cost
                        

                        obj.paint_list.push({
                            paint_name : paintData.paint_name, // cat name,
                            paint_code : paintData.paint_code, // kode paint,
                            used_weight : parseFloat(curData[curKey]),
                            total_price : cost
                        })
                        found++
                        
                    }


                }
                console.log(total , found)
                this.calculateTotal()
            }
            
			reader.readAsBinaryString(file);
            
        },
        addCar (form_code = null) {
            if(!form_code) form_code = this.selectWo
            this.selectWo = null

            if(!form_code) {
                this.$store.dispatch('triggerAlert' , [false , 'Mohon pilih work order terlebih dahulu.'])
                return
            }
            
            let index = this.form.use_paint_list.findIndex(x => x.form_code == form_code)
            if(index != -1){
                // this.$store.dispatch('triggerAlert' , [false , 'Work Order Sudah Di Masukkan'] )
                
                return index
            }
                
            let object = JSON.parse(JSON.stringify(this.use_paint_list_model))
            let formData = this.$options.workorder_list.find(x => x.form_code == form_code)
            console.log(formData)
            object.chassis_number = formData.chassis_number
            object.no_polisi = formData.no_polisi
            object.form_code = formData.form_code

            // object.paint_list.push(JSON.parse(JSON.stringify(this.paint_list_model)))

            this.form.use_paint_list.push(object)
            return this.form.use_paint_list.length - 1
        },
        getCatBrand () {
            this.$http.get('/api/v1/masterData/cat-brand')
            .then((resp) => {
                this.options.cat_brand = resp.data.data
            })
            .catch((err) => {
                console.log(err)
            })
        },
        getPaintList () {
            this.$http.get('/api/v1/masterData/cat-brand/' + this.form.cat_brand_id)
            .then((resp) => {
                this.options.paint_list = resp.data.data
            })
            .catch((err) => {
                console.log(err)
            })
        },
        async loadWorkOrder(search = null) {
            // this.woList = [];
            this.$http
                .get(
                    '/api/v1/masterData/workorder?pagination=false&order=DESC&by=created_at'
                )
                .then(resp => {
                    // this.woList = resp.data.data
                    let data = resp.data.data

                    for (var i = 0; i < data.length; i++) {
                        data[i].name =
                            data[i].form_code +
                            ' - ' +
                            data[i].no_polisi +
                            ' - ' +
                            data[i].car_name;
                    }
                    // this.$set(this, 'woList', resp.data.data);
                    this.$options.workorder_list = data
                })
                .catch(err => {
                    console.log(err);
                });
        },
        evaluateForm () {
            let error = []
            let form = JSON.parse(JSON.stringify(this.form))
            console.log(form , form.use_paint_list.length == 0)

            if(form.use_paint_list.length == 0) {
                // ga boleh kosong
                error.push('Work Order List Cannot Be Empty')
                return error
            }

            for(var i = 0 ; i < form.use_paint_list.length ; i++) {
                if(form.use_paint_list[i].paint_list.length == 0) {
                    error.push('Paint List Cannot Be Empty')
                    break;
                }

                form.use_paint_list[i].paint_list = form.use_paint_list[i].paint_list.map(function(x) {
                    if(x.paint_code){
                        // console.log(x.used_weight != '' , !x.used_weight , x.used_weight)
                        if(x.used_weight != ''  && x.used_weight)
                            return x
                        else {
                            error.push(`${x.paint_code} weight usage cannot be zero!`)
                        }
                    }      
                })
            }

            return {error , form};
            
        },
        // async getLastIndex (supplier_id , type) {
		// 	try {
		// 		let response = await this.$http.post('/api/v1/treasury/supplier-voucher/index?supplier_id=' + supplier_id , {type : type})
		// 		// console.log(response)
		// 		return response.data.data.sv_id	
		// 	}
		// 	catch(err) {
		// 		this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong in Fetching Supplier Code. Please Try Again Later.'])
		// 		console.log(err)
		// 	}
		// },
        async submitData () {
            // console.log(this.evaluateForm())
            let {error , form} = this.evaluateForm()

            if(error.length > 0) {
                let array = [false].concat(error)
                this.$store.dispatch('triggerAlert' , array)
                return
            }
            // console.log('submitted')

            // Post Data Here
            try {
                let response = await this.$http.post('/api/v1/treasury/insert-voucher-estimations-cat' , form)
                
                // console.log(response.data.data)
                this.$store.dispatch('triggerAlert' , [true , 'Selesai Input Voucher Cat']);
                this.$router.push({ name : 'SupplierVoucher'})
            }
            catch(err) {
                console.log(err)
                this.$store.dispatch('triggerAlert' , [false , 'Error! Please Contact Administrator!'])

            }
            
            console.log(form)
        }
    }
}
</script>

<style>
	.middleDiv {
		margin-top: auto;
		margin-bottom: auto;
	}
</style>